import { render } from "./SalePos.vue?vue&type=template&id=23cfba52&scoped=true"
import script from "./SalePos.vue?vue&type=script&lang=js"
export * from "./SalePos.vue?vue&type=script&lang=js"

import "./SalePos.vue?vue&type=style&index=0&id=23cfba52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cfba52"]])

export default __exports__